<template>
    <div>
        <b-card bg-variant="white" text-variant="dark" :title="translationData.trackingOrder" class="card-roadmap"> 
        <b-container>
            <b-row align-h="center">
                <template v-if="this.data.transhipment.length > 0">
                    <template v-if="(this.data.manualAdjustment.length > 0 && this.data.distribution.length > 0 && (this.data.manualAdjustment[0].events[0].created > this.data.distribution[0].events[0].created && this.data.distribution[0].events[0].photo.length == 0))  || (this.data.manualAdjustment.length > 0 && this.data.distribution.length == 0) || this.manual" >
                        <template v-if="this.data.documentInfo.status_stop_id != 3
                                && this.data.documentInfo.status_stop_id != 4
                                && this.data.documentInfo.status_stop_id != 8
                                && this.data.documentInfo.status_stop_id != 6
                                && this.data.documentInfo.status_stop_id != 9
                                && this.data.documentInfo.status_stop_id != 14
                                && this.data.documentInfo.status_stop_id != 15">
                            <b-col sm="6">
                                <b-row cols="3" class="mb-0 roadmap-active">
                                    <b-col align-h="center">
                                        <span class="line line_active"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                        <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                    </b-col>
                                    <b-col align-h="center" class="roadmap-active">
                                        <span class="line line_active"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/warehouse_green.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.inTransfer }}</p>
                                        <p class="roadmap_item_detail">{{ this.data.transhipment[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                    </b-col>
                                    <b-col align-h="center" class="roadmap-active">
                                        <span class="line line_active"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/hourglass_green.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.transferred }}</p>
                                        <p class="roadmap_item_detail">{{ this.data.transhipment[0].end_route | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                    </b-col>  
                                </b-row>
                            </b-col>
                            <b-col sm="6">
                                <b-row cols="3" class="mb-0 roadmap-active">
                                    <b-col align-h="center">
                                        <span class="line line_active"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">
                                            <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                            {{ translationData.onDelivery }}
                                            </span>
                                            <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                            {{ translationData.released }}
                                            </span>
                                            <span v-else>
                                            {{ translationData.onRoute }}
                                            </span>
                                        </p>
                                        <p class="roadmap_item_detail">{{ this.data.manualAdjustment[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                    </b-col>
                                    <b-col align-h="center" class="roadmap-disabled">
                                        <span class="line"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/box.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                        <p class="roadmap_item_detail"></p>
                                    </b-col>
                                    <b-col align-h="center" class="roadmap-disabled">
                                        <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </template>

                        <template v-else>

                            <template v-if="this.data.documentInfo.status_stop_id == 6
                                || this.data.documentInfo.status_stop_id == 9
                                || this.data.documentInfo.status_stop_id == 14">

                                <b-col sm="6">
                                    <b-row cols="3" class="mb-0 roadmap-active">
                                        <b-col align-h="center">
                                            <span class="line line_active"> </span>
                                            <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                            <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                        </b-col>
                                        <b-col align-h="center" class="roadmap-active">
                                            <span class="line line_active"> </span>
                                            <div class="icon_wrapper"><b-img src="@/assets/warehouse_green.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">{{ translationData.inTransfer }}</p>
                                            <p class="roadmap_item_detail">{{ this.data.transhipment[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                        </b-col>
                                        <b-col align-h="center" class="roadmap-active">
                                            <span class="line line_active"> </span>
                                            <div class="icon_wrapper"><b-img src="@/assets/hourglass_green.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">{{ translationData.transferred }}</p>
                                            <p class="roadmap_item_detail">{{ this.data.transhipment[0].end_route | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col sm="6">
                                    <b-row cols="3" class="mb-0 roadmap-active ">
                                        <b-col align-h="center">
                                            <span class="line line_active"> </span>
                                            <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">
                                                <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                                {{ translationData.onDelivery }}
                                                </span>
                                                <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                    {{ translationData.released }}
                                                </span>
                                                <span v-else>
                                                {{ translationData.onRoute }}
                                                </span>
                                            </p>
                                            <p class="roadmap_item_detail">{{ this.data.manualAdjustment[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                        </b-col>
                                        <b-col align-h="center" class="roadmap-active">
                                            <span class="line line_active"> </span>
                                            <div class="icon_wrapper"><b-img src="@/assets/box_red.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">{{ translationData.notDelivered }}<br>{{ this.data.manualAdjustment[0].events[0].button_text }}</p>
                                            <p class="roadmap_item_detail">{{ this.data.manualAdjustment[0].events[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                        </b-col>
                                        <b-col align-h="center" class="roadmap-disabled" v-b-modal.modal_picture centered>
                                            <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </template>

                            <template v-else>
                                <template v-if="this.data.documentInfo.status_stop_id == 15 || this.data.manualAdjustment[0].status_stop_id == 15">

                                    <b-col sm="6">
                                        <b-row cols="3" class="mb-0 roadmap-active">
                                            <b-col align-h="center">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                                <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                            </b-col>
                                            <b-col align-h="center" class="roadmap-active">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/warehouse_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.inTransfer }}</p>
                                                <p class="roadmap_item_detail">{{ this.data.transhipment[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                            </b-col>
                                            <b-col align-h="center" class="roadmap-active">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/hourglass_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.transferred }}</p>
                                                <p class="roadmap_item_detail">{{ this.data.transhipment[0].end_route | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-row cols="3" class="mb-0 roadmap-active">
                                            <b-col align-h="center">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">
                                                    <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                                    {{ translationData.onDelivery }}
                                                    </span>
                                                    <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                        {{ translationData.released }}
                                                    </span>
                                                    <span v-else>
                                                    {{ translationData.onRoute }}
                                                    </span>
                                                    </p>
                                                <p class="roadmap_item_detail"></p>
                                            </b-col>
                                            <b-col align-h="center" class="roadmap-disabled">
                                                <span class="line "> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/box.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                                <p class="roadmap_item_detail"></p>
                                            </b-col>
                                            <b-col align-h="center" class="roadmap-disabled">
                                                <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </template>
                                
                                <template v-else>
                                    <b-col sm="6">
                                        <b-row cols="3" class="mb-0 roadmap-active">
                                            <b-col align-h="center">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                                <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                            </b-col>
                                            <b-col align-h="center" class="roadmap-active">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/warehouse_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.inTransfer }}</p>
                                                <p class="roadmap_item_detail">{{ this.data.transhipment[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                            </b-col>
                                            <b-col align-h="center" class="roadmap-active">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/hourglass_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.transferred }}</p>
                                                <p class="roadmap_item_detail">{{ this.data.transhipment[0].end_route | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-row cols="3" class="mb-0 roadmap-active">
                                            <b-col align-h="center">
                                                <span class="line  line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">
                                                    <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                                    {{ translationData.onDelivery }}
                                                    </span>
                                                    <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                        {{ translationData.released }}
                                                    </span>
                                                    <span v-else>
                                                    {{ translationData.onRoute }}
                                                    </span>
                                                </p>
                                                <p class="roadmap_item_detail">{{ this.data.manualAdjustment[0].created | moment("utc","DD/MM/YYYY") }}</p>
                                            </b-col>
                                            <b-col align-h="center" class="roadmap-active">
                                                <span class="line  line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/box_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                                <p class="roadmap_item_detail">{{ this.data.manualAdjustment[0].events[0].created | moment("utc","DD/MM/YYYY") }}</p>
                                            </b-col>
                                            <b-col align-h="center" class="roadmap-active" v-b-modal.modal_picture centered style="cursor: pointer;">
                                                <div class="icon_wrapper"><b-img src="@/assets/photo_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                            </b-col>
                                        </b-row>
                                        <b-modal centered size="xl" id="modal_picture" :title="translationData.notePhoto" hide-footer>
                                            <template v-if="this.data.manualAdjustment[0].events[0].photo != null">
                                                <template v-for="event in this.data.manualAdjustment[0].events">
                                                    <template v-if="event.photo.includes('.pdf')">
                                                        <VuePdfEmbed :source="getDocumentImageUrlManualAdjustment(event.photo)" />                                                         
                                                    </template>
                                                    <template v-else>
                                                        <b-img class="img_style" :src="getDocumentImageUrlManualAdjustment(event.photo)" />
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-else>
                                               {{ translationData.notAvailable }}
                                            </template>
                                        </b-modal>
                                    </b-col>
                                </template>
                            </template>
                        </template>
                    </template>

                    <template v-else>   

                        <template v-if="this.data.documentInfo.status_stop_id == 12 && this.data.distribution.length == 0">
                            <b-col sm="6">
                                <b-row cols="3" class="mb-0">
                                    <b-col align-h="center">
                                        <span class="line "> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                        <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                    </b-col>
                                    <b-col align-h="center" class="roadmap-disabled">
                                        <span class="line"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/warehouse.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.inTransfer }}</p>
                                        <p class="roadmap_item_detail"></p>
                                    </b-col>
                                    <b-col align-h="center" class="roadmap-disabled">
                                        <span class="line"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/hourglass.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.transferred }}</p>
                                        <p class="roadmap_item_detail"></p>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="6">
                                <b-row cols="3" class="mb-0">
                                    <b-col align-h="center" class="roadmap-disabled">
                                        <span class="line"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/delivery.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">
                                            <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                            {{ translationData.onDelivery }}
                                            </span>
                                            <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                {{ translationData.released }}
                                            </span>
                                            <span v-else>
                                            {{ translationData.onRoute }}
                                            </span>
                                        </p>
                                        <p class="roadmap_item_detail"></p>
                                    </b-col>
                                    <b-col align-h="center" class="roadmap-disabled">
                                        <span class="line"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/box.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                        <p class="roadmap_item_detail"></p>
                                    </b-col>
                                    <b-col align-h="center" class="roadmap-disabled">
                                        <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </template>

                        <template v-else>

                            <template v-if="(this.data.documentInfo.status_stop_id == 0 || this.data.documentInfo.status_stop_id == 18) && this.data.distribution.length == 0">
                                <b-col sm="6">
                                    <b-row cols="3" class="mb-0 roadmap-active">
                                        <b-col align-h="center">
                                            <span class="line line_active"> </span>
                                            <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                            <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                        </b-col>
                                        <b-col align-h="center">
                                            <span class="line  line_active"> </span>
                                            <div class="icon_wrapper"><b-img src="@/assets/warehouse_green.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">{{ translationData.inTransfer }}</p>
                                            <p class="roadmap_item_detail">{{ this.data.transhipment[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                        </b-col>
                                        <b-col align-h="center" class="roadmap-disabled">
                                            <span class="line"> </span>
                                            <div class="icon_wrapper"><b-img src="@/assets/hourglass.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">{{ translationData.transferred }}</p>
                                            <p class="roadmap_item_detail"></p>
                                        </b-col>                         
                                    </b-row>
                                </b-col>
                                <b-col sm="6">
                                    <b-row cols="3" class="mb-0">
                                        <b-col align-h="center" class="roadmap-disabled">
                                            <span class="line"> </span>
                                            <div class="icon_wrapper"><b-img src="@/assets/delivery.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">
                                                <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                                {{ translationData.onDelivery }}
                                                </span>
                                                <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                    {{ translationData.released }}
                                                </span>
                                                <span v-else>
                                                {{ translationData.onRoute }}
                                                </span>
                                            </p>
                                            <p class="roadmap_item_detail"></p>
                                        </b-col>
                                        <b-col align-h="center" class="roadmap-disabled">
                                            <span class="line"> </span>
                                            <div class="icon_wrapper"><b-img src="@/assets/box.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                            <p class="roadmap_item_detail"></p>
                                        </b-col>
                                        <b-col align-h="center" class="roadmap-disabled">
                                            <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </template>

                            <template v-else>

                                <template v-if="this.data.documentInfo.status_stop_id == 17 && this.data.distribution.length == 0">
                                    <b-col sm="6">
                                        <b-row cols="3" class="mb-0 roadmap-active">
                                            <b-col align-h="center">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                                <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                            </b-col>
                                        <b-col align-h="center" class="roadmap-active">
                                            <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/warehouse_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.inTransfer }}</p>
                                                <p class="roadmap_item_detail">{{ this.data.transhipment[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                            </b-col>
                                            <b-col align-h="center" class="roadmap-active">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/hourglass_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.transferred }}</p>
                                                <p class="roadmap_item_detail">{{ this.data.transhipment[0].end_route | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-row cols="3" class="mb-0 roadmap-active">
                                            <b-col align-h="center" class="roadmap-disabled">
                                                <span class="line"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/delivery.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">
                                                    <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                                    {{ translationData.onDelivery }}
                                                    </span>
                                                    <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                        {{ translationData.released }}
                                                    </span>
                                                    <span v-else>
                                                    {{ translationData.onRoute }}
                                                    </span>
                                                    </p>
                                                <p class="roadmap_item_detail"></p>
                                            </b-col>
                                            <b-col align-h="center" class="roadmap-disabled">
                                                <span class="line"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/box.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                                <p class="roadmap_item_detail"></p>
                                            </b-col>
                                            <b-col align-h="center" class="roadmap-disabled">
                                                <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </template>

                                <template v-else>

                                    <template v-if="this.data.distribution.length > 0
                                            && this.data.documentInfo.status_stop_id != 3
                                            && this.data.documentInfo.status_stop_id != 4
                                            && this.data.documentInfo.status_stop_id != 8
                                            && this.data.documentInfo.status_stop_id != 6
                                            && this.data.documentInfo.status_stop_id != 9
                                            && this.data.documentInfo.status_stop_id != 14
                                            && this.data.documentInfo.status_stop_id != 15">
                                        <b-col sm="6">
                                            <b-row cols="3" class="mb-0 roadmap-active">
                                                <b-col align-h="center">
                                                    <span class="line line_active"> </span>
                                                    <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                                    <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                                    <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                                </b-col>
                                                <b-col align-h="center" class="roadmap-active">
                                                    <span class="line line_active"> </span>
                                                    <div class="icon_wrapper"><b-img src="@/assets/warehouse_green.png" fluid></b-img></div>
                                                    <p class="roadmap_item_title">{{ translationData.inTransfer }}</p>
                                                    <p class="roadmap_item_detail">{{ this.data.transhipment[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                                </b-col>
                                                <b-col align-h="center" class="roadmap-active">
                                                    <span class="line line_active"> </span>
                                                    <div class="icon_wrapper"><b-img src="@/assets/hourglass_green.png" fluid></b-img></div>
                                                    <p class="roadmap_item_title">{{ translationData.transferred }}</p>
                                                    <p class="roadmap_item_detail">{{ this.data.transhipment[0].end_route | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                                </b-col>  
                                            </b-row>
                                        </b-col>
                                        <b-col sm="6">
                                            <b-row cols="3" class="mb-0 roadmap-active">
                                                <b-col align-h="center">
                                                    <span class="line line_active"> </span>
                                                    <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                                    <p class="roadmap_item_title">
                                                        <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                                        {{ translationData.onDelivery }}
                                                        </span>
                                                        <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                            {{ translationData.released }}
                                                        </span>
                                                        <span v-else>
                                                        {{ translationData.onRoute }}
                                                        </span>
                                                    </p>
                                                    <p class="roadmap_item_detail">{{ this.data.distribution[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                                </b-col>
                                                <b-col align-h="center" class="roadmap-disabled">
                                                    <span class="line "> </span>
                                                    <div class="icon_wrapper"><b-img src="@/assets/box.png" fluid></b-img></div>
                                                    <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                                    <p class="roadmap_item_detail"></p>
                                                </b-col>
                                                <b-col align-h="center" class="roadmap-disabled">
                                                    <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                                    <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </template>

                                    <template v-else>

                                        <template v-if="this.data.distribution.length > 0
                                            && (this.data.documentInfo.status_stop_id == 6
                                            || this.data.documentInfo.status_stop_id == 9
                                            || this.data.documentInfo.status_stop_id == 14)">

                                            <b-col sm="6">
                                                <b-row cols="3" class="mb-0 roadmap-active">
                                                    <b-col align-h="center">
                                                        <span class="line line_active"> </span>
                                                        <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                                        <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                                        <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                                    </b-col>
                                                    <b-col align-h="center" class="roadmap-active">
                                                        <span class="line line_active"> </span>
                                                        <div class="icon_wrapper"><b-img src="@/assets/warehouse_green.png" fluid></b-img></div>
                                                        <p class="roadmap_item_title">{{ translationData.inTransfer }}</p>
                                                        <p class="roadmap_item_detail">{{ this.data.transhipment[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                                    </b-col>
                                                    <b-col align-h="center" class="roadmap-active">
                                                        <span class="line line_active"> </span>
                                                        <div class="icon_wrapper"><b-img src="@/assets/hourglass_green.png" fluid></b-img></div>
                                                        <p class="roadmap_item_title">{{ translationData.transferred }}</p>
                                                        <p class="roadmap_item_detail">{{ this.data.transhipment[0].end_route | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col sm="6">
                                                <b-row cols="3" class="mb-0 roadmap-active ">
                                                    <b-col align-h="center">
                                                        <span class="line line_active"> </span>
                                                        <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                                        <p class="roadmap_item_title">
                                                            <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                                            {{ translationData.onDelivery }}
                                                            </span>
                                                            <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                                {{ translationData.released }}
                                                            </span>
                                                            <span v-else>
                                                            {{ translationData.onRoute }}
                                                            </span>
                                                        </p>
                                                        <p class="roadmap_item_detail">{{ this.data.distribution[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                                    </b-col>
                                                    <b-col align-h="center" class="roadmap-active">
                                                        <span class="line line_active"> </span>
                                                        <div class="icon_wrapper"><b-img src="@/assets/box_red.png" fluid></b-img></div>
                                                        <p class="roadmap_item_title">{{ translationData.notDelivered }}<br>{{ this.data.distribution[0].events[0].button_text }}</p>
                                                        <p class="roadmap_item_detail">{{ this.data.distribution[0].events[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                                    </b-col>
                                                    <b-col align-h="center" class="roadmap-disabled" v-b-modal.modal_picture centered>
                                                        <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                                        <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                                    </b-col>
                                                </b-row>
                                            </b-col>                       
                                        </template>

                                        <template v-else> 
                                            <template v-if="this.data.documentInfo.status_stop_id == 15">
                                                <b-col sm="6">
                                                    <b-row cols="3" class="mb-0 roadmap-active">
                                                        <b-col align-h="center">
                                                            <span class="line line_active"> </span>
                                                            <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                                            <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                                            <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                                        </b-col>
                                                        <b-col align-h="center" class="roadmap-active">
                                                            <span class="line line_active"> </span>
                                                            <div class="icon_wrapper"><b-img src="@/assets/warehouse_green.png" fluid></b-img></div>
                                                            <p class="roadmap_item_title">{{ translationData.inTransfer }}</p>
                                                            <p class="roadmap_item_detail">{{ this.data.transhipment[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                                        </b-col>
                                                        <b-col align-h="center" class="roadmap-active">
                                                            <span class="line line_active"> </span>
                                                            <div class="icon_wrapper"><b-img src="@/assets/hourglass_green.png" fluid></b-img></div>
                                                            <p class="roadmap_item_title">{{ translationData.transferred }}</p>
                                                            <p class="roadmap_item_detail">{{ this.data.transhipment[0].end_route | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                                <b-col sm="6">
                                                    <b-row cols="3" class="mb-0 roadmap-active">
                                                        <b-col align-h="center">
                                                            <span class="line line_active"> </span>
                                                            <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                                            <p class="roadmap_item_title">
                                                                <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                                                {{ translationData.onDelivery }}
                                                                </span>
                                                                <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                                    {{ translationData.released }}
                                                                </span>
                                                                <span v-else>
                                                                {{ translationData.onRoute }}
                                                                </span>
                                                            </p>
                                                            <p class="roadmap_item_detail"></p>
                                                        </b-col>
                                                        <b-col align-h="center" class="roadmap-disabled">
                                                            <span class="line "> </span>
                                                            <div class="icon_wrapper"><b-img src="@/assets/box.png" fluid></b-img></div>
                                                            <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                                            <p class="roadmap_item_detail"></p>
                                                        </b-col>
                                                        <b-col align-h="center" class="roadmap-disabled">
                                                            <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                                            <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                            </template>

                                            <template v-else>
                                                <b-col sm="6">
                                                    <b-row cols="3" class="mb-0 roadmap-active">
                                                        <b-col align-h="center">
                                                            <span class="line line_active"> </span>
                                                            <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                                            <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                                            <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                                        </b-col>
                                                        <b-col align-h="center" class="roadmap-active">
                                                            <span class="line line_active"> </span>
                                                            <div class="icon_wrapper"><b-img src="@/assets/warehouse_green.png" fluid></b-img></div>
                                                            <p class="roadmap_item_title">{{ translationData.inTransfer }}</p>
                                                            <p class="roadmap_item_detail">{{ this.data.transhipment[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                                        </b-col>
                                                        <b-col align-h="center" class="roadmap-active">
                                                            <span class="line line_active"> </span>
                                                            <div class="icon_wrapper"><b-img src="@/assets/hourglass_green.png" fluid></b-img></div>
                                                            <p class="roadmap_item_title">{{ translationData.transferred }}</p>
                                                            <p class="roadmap_item_detail">{{ this.data.transhipment[0].end_route | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>

                                                <template v-if="this.data.distribution.length > 0">
                                                    <b-col sm="6">
                                                        <b-row cols="3" class="mb-0 roadmap-active">
                                                            <b-col align-h="center">
                                                                <span class="line line_active"> </span>
                                                                <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                                                <p class="roadmap_item_title">
                                                                    <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                                                    {{ translationData.onDelivery }}
                                                                    </span>
                                                                    <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                                        {{ translationData.released }}
                                                                    </span>
                                                                    <span v-else>
                                                                    {{ translationData.onRoute }}
                                                                    </span>
                                                                </p>
                                                                <p class="roadmap_item_detail">{{ this.data.distribution[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                                            </b-col>
                                                            <b-col align-h="center" class="roadmap-active">
                                                                <span class="line line_active"> </span>
                                                                <div class="icon_wrapper"><b-img src="@/assets/box_green.png" fluid></b-img></div>
                                                                <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                                                <p class="roadmap_item_detail">{{ this.data.distribution[0].events[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                                            </b-col>
                                                            <b-col align-h="center" class="roadmap-active" v-b-modal.modal_picture centered style="cursor: pointer;">
                                                                <div class="icon_wrapper"><b-img src="@/assets/photo_green.png" fluid></b-img></div>
                                                                <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                                            </b-col>
                                                        </b-row>
                                                        <b-modal centered size="xl" id="modal_picture" :title="translationData.notePhoto" hide-footer>
                                                            <template v-if="this.data.distribution[0].events[0].photo != null">
                                                                <template v-for="event in this.data.distribution[0].events">
                                                                    <template v-if="event.photo.includes('.pdf')">
                                                                        <VuePdfEmbed :source="getDocumentImageUrl(event.photo)" />                                                         
                                                                    </template>
                                                                    <template v-else>
                                                                        <b-img class="img_style" :src="getDocumentImageUrl(event.photo)" />
                                                                    </template>
                                                                </template>
                                                            </template>
                                                            <template v-else>
                                                                {{ translationData.notAvailable }}
                                                            </template>
                                                        </b-modal>
                                                    </b-col>
                                                </template>
                                                <template v-else>
                                                    <template v-if="this.data.distribution.length == 0 && this.data.manualAdjustment.length == 0">
                                                        <b-col sm="4">
                                                            <b-row cols="2" class="mb-0 roadmap-active">
                                                                <b-col align-h="center">
                                                                    <span class="line line-active"> </span>
                                                                <div class="icon_wrapper"><b-img src="@/assets/box_green.png" fluid></b-img></div>
                                                                    <p class="roadmap_item_title">Nota entregue</p>
                                                                    <p class="roadmap_item_detail">{{ this.data.transhipment[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                                                </b-col>
                                                                <b-col align-h="center" class="roadmap-active" v-b-modal.modal_picture centered style="cursor: pointer;">
                                                                    <div class="icon_wrapper"><b-img src="@/assets/photo_green.png" fluid></b-img></div>
                                                                    <p class="roadmap_item_title">Clique para ver o canhoto</p>
                                                                </b-col>
                                                            </b-row>
                                                            <b-modal centered size="xl" id="modal_picture" title="Foto do canhoto" hide-footer>
                                                                <template v-if="this.data.transhipment[0].events[0].photo != null">
                                                                    <template v-for="(event, index) in this.data.transhipment[0].events">
                                                                        <b-img :src="getDocumentImageUrl(event.photo)" fluid :key="index"></b-img>
                                                                        </template>
                                                                        </template>
                                                                        <template v-else>
                                                                            Não disponível
                                                                            </template>
                                                                            </b-modal>
                                                        </b-col>
                                                    </template>
                                                
                                                    <template v-else>
                                                        <b-col sm="4">
                                                            <b-row cols="2" class="mb-0 roadmap-disabled">
                                                                <b-col align-h="center">
                                                                    <span class="line"> </span>
                                                                <div class="icon_wrapper"><b-img src="@/assets/box.png" fluid></b-img></div>
                                                                    <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                                                    <p class="roadmap_item_detail"></p>
                                                                </b-col>
                                                                <b-col align-h="center" class="roadmap-disabled" centered>
                                                                    <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                                                    <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                                                </b-col>
                                                            </b-row>
                                                        </b-col>
                                                    </template> 
                                                </template> 
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </template>
                    </template>
                </template>

                <template v-else>
                    <template v-if="(this.data.manualAdjustment.length > 0 && this.data.distribution.length > 0 && (this.data.manualAdjustment[0].events[0].created > this.data.distribution[0].events[0].created))  || (this.data.manualAdjustment.length > 0 && this.data.distribution.length == 0)" >

                        <template v-if="this.data.documentInfo.status_stop_id == 3
                                    || this.data.documentInfo.status_stop_id == 4
                                    || this.data.documentInfo.status_stop_id == 8">

                            <b-col align-h="center" class="roadmap-active col-small">
                                <span class="line line_active"> </span>
                                <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                            </b-col>
                            <b-col align-h="center" class="roadmap-active col-small">
                                <span class="line line_active"> </span>
                                <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                <p class="roadmap_item_title">
                                            <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                            {{ translationData.onDelivery }}
                                            </span>
                                            <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                {{ translationData.released }}
                                            </span>
                                            <span v-else>
                                            {{ translationData.onRoute }}
                                            </span>
                                        </p>
                                <p class="roadmap_item_detail">{{ this.data.manualAdjustment[0].created | moment("utc","DD/MM/YYYY") }}</p>
                            </b-col>
                            <b-col align-h="center" class="roadmap-active">
                                <span class="line line_active"> </span>
                                <div class="icon_wrapper"><b-img src="@/assets/box_green.png" fluid></b-img></div>
                                <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                <p class="roadmap_item_detail">{{ this.data.manualAdjustment[0].events[0].created | moment("utc","DD/MM/YYYY") }}</p>
                            </b-col>
                            <b-col align-h="center" class="roadmap-active" v-b-modal.modal_picture centered style="cursor: pointer;">
                                <div class="icon_wrapper"><b-img src="@/assets/photo_green.png" fluid></b-img></div>
                                <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                            </b-col>
                            <b-modal centered size="xl" id="modal_picture" :title = "translationData.notePhoto" hide-footer>
                                <template v-if="this.data.manualAdjustment[0].events[0].photo != null">
                                    <template v-for="event in this.data.manualAdjustment[0].events">
                                        <template v-if="event.photo.includes('.pdf')">
                                            <VuePdfEmbed :source="getDocumentImageUrlManualAdjustment(event.photo)" />                                                         
                                        </template>
                                        <template v-else>
                                            <b-img class="img_style" :src="getDocumentImageUrlManualAdjustment(event.photo)" />
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                                    {{ translationData.notAvailable }}
                                </template>
                            </b-modal>

                        </template>

                        <template v-else>

                            <b-col align-h="center" class="roadmap-active col-small">
                                <span class="line line_active"> </span>
                                <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                            </b-col>
                            <b-col align-h="center" class="roadmap-active col-small">
                                <span class="line line_active"> </span>
                                <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                <p class="roadmap_item_title">
                                            <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                            {{ translationData.onDelivery }}
                                            </span>
                                            <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                {{ translationData.released }}
                                            </span>
                                            <span v-else>
                                            {{ translationData.onRoute }}
                                            </span>
                                        </p>
                                <p class="roadmap_item_detail">{{ this.data.manualAdjustment[0].created | moment("utc","DD/MM/YYYY") }}</p>
                            </b-col>
                            <b-col align-h="center" class="col-small roadmap-active">
                                <span class="line line_active"> </span>
                                <div class="icon_wrapper"><b-img src="@/assets/box_red.png" fluid></b-img></div>
                                <p class="roadmap_item_title">{{ translationData.notDelivered }}<br>{{ this.data.manualAdjustment[0].events[0].button_text }}</p>
                                <p class="roadmap_item_detail">{{ this.data.manualAdjustment[0].events[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                            </b-col>
                            <b-col align-h="center"  class="col-small roadmap-disabled" v-b-modal.modal_picture centered>
                                <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                            </b-col>
                            <b-modal centered size="xl" id="modal_picture" :title = "translationData.notePhoto" hide-footer>
                                <template v-if="this.data.manualAdjustment[0].events[0].photo != null">
                                   <template v-for="event in this.data.manualAdjustment[0].events">
                                        <template v-if="event.photo.includes('.pdf')">
                                            <VuePdfEmbed :source="getDocumentImageUrlManualAdjustment(event.photo)" />                                                         
                                        </template>
                                        <template v-else>
                                            <b-img class="img_style" :src="getDocumentImageUrlManualAdjustment(event.photo)" />
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                                    {{ translationData.notAvailable }}
                                </template>
                            </b-modal>
                        </template>    
                    </template>

                    <template v-else>

                        <template v-if="this.data.distribution.length > 0">
                            <template v-if="this.data.documentInfo.status_stop_id != 3
                                        && this.data.documentInfo.status_stop_id != 4
                                        && this.data.documentInfo.status_stop_id != 8
                                        && this.data.documentInfo.status_stop_id != 6
                                        && this.data.documentInfo.status_stop_id != 9
                                        && this.data.documentInfo.status_stop_id != 13
                                        && this.data.documentInfo.status_stop_id != 14
                                        && this.data.documentInfo.status_stop_id != 15">

                                <b-col align-h="center" class="roadmap-active col-small">
                                    <span class="line line_active"> </span>
                                    <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                    <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                    <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                </b-col>
                                <b-col align-h="center" class="roadmap-active col-small">
                                    <span class="line line_active"> </span>
                                    <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                    <span v-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                        <p class="roadmap_item_title">{{ translationData.released }}</p>
                                    </span>
                                    <span v-else>
                                        <p class="roadmap_item_title">{{ translationData.onRoute }}</p>
                                    </span>
                                    <p class="roadmap_item_detail">{{ this.data.distribution[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                </b-col>
                                <b-col align-h="center" class="roadmap-disabled col-small">
                                    <span class="line"> </span>
                                    <div class="icon_wrapper"><b-img src="@/assets/box.png" fluid></b-img></div>
                                    <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                    <p class="roadmap_item_detail"></p>
                                </b-col>
                                <b-col align-h="center" class="roadmap-disabled col-small">
                                    <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                    <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                </b-col>
                                <span class="line"> </span>
                            </template>

                            <template v-else>

                                <template v-if="this.data.documentInfo.status_stop_id == 6
                                            || this.data.documentInfo.status_stop_id == 9
                                            || this.data.documentInfo.status_stop_id == 13
                                            || this.data.documentInfo.status_stop_id == 14">

                                    <b-col align-h="center" class="col-small roadmap-active">
                                        <span class="line line_active"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                        <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                    </b-col>
                                    <b-col align-h="center" class="col-small roadmap-active">
                                        <span class="line line_active"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">
                                            <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                            {{ translationData.onDelivery }}
                                            </span>
                                            <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                {{ translationData.released }}
                                            </span>
                                            <span v-else>
                                            {{ translationData.onRoute }}
                                            </span>
                                        </p>
                                        <p class="roadmap_item_detail">{{ this.data.distribution[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                    </b-col>
                                    <b-col align-h="center" class="col-small roadmap-active">
                                        <span class="line line_active"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/box_red.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.notDelivered }}<br>{{ this.data.distribution[0].events[0].button_text }}</p>
                                        <p class="roadmap_item_detail">{{ this.data.distribution[0].events[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                    </b-col>
                                    <b-col align-h="center"  class="col-small roadmap-disabled" v-b-modal.modal_picture centered>
                                        <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                    </b-col>

                                </template> 

                                <template v-else>

                                     <template v-if="this.data.documentInfo.status_stop_id == 15" >
                                            <b-col align-h="center" class="col-small roadmap-active">
                                            <span class="line line_active"> </span>
                                            <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                            <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                        </b-col>
                                        <b-col align-h="center" class="col-small roadmap-active">
                                            <span class="line line_active"> </span>
                                            <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">
                                                <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                                {{ translationData.onDelivery }}
                                                </span>
                                                <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                    {{ translationData.released }}
                                                </span>
                                                <span v-else>
                                                {{ translationData.onRoute }}
                                                </span>
                                        </p>
                                            <p class="roadmap_item_detail"></p>
                                        </b-col>
                                        <b-col align-h="center" class="col-small roadmap-disabled">
                                            <span class="line"> </span>
                                            <div class="icon_wrapper"><b-img src="@/assets/box_green.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                            <p class="roadmap_item_detail"></p>
                                        </b-col>
                                        <b-col align-h="center"  class="col-small roadmap-disabled">
                                            <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                            <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                        </b-col>
                                    </template> 

                                    <template v-else>

                                        <template v-if="this.data.distribution[0].events.length == 0
                                                    && this.data.manualAdjustment.length > 0" >
                                                    
                                            <b-col align-h="center" class="col-small roadmap-active">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                                <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                            </b-col>
                                            <b-col align-h="center" class="col-small roadmap-active">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">
                                                    <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                                    {{ translationData.onDelivery }}
                                                    </span>
                                                    <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                        {{ translationData.released }}
                                                    </span>
                                                    <span v-else>
                                                    {{ translationData.onRoute }}
                                                    </span>
                                                </p>
                                                <p class="roadmap_item_detail">{{ this.data.distribution[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                            </b-col>
                                            <b-col align-h="center" class="col-small roadmap-active">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/box_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                                <p class="roadmap_item_detail">{{ this.data.manualAdjustment[0].events[0].created | moment("utc","DD/MM/YYYY") }}</p>
                                            </b-col>
                                            <b-col align-h="center"  class="col-small roadmap-active" v-b-modal.modal_picture centered style="cursor: pointer;">
                                                <div class="icon_wrapper"><b-img src="@/assets/photo_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                            </b-col>
                                            <b-modal centered size="xl" id="modal_picture" :title = "translationData.notePhoto" hide-footer>
                                                <template v-if="this.data.manualAdjustment[0].events[0].photo != null">
                                                   <template v-for="event in this.data.manualAdjustment[0].events">
                                                        <template v-if="event.photo.includes('.pdf')">
                                                            <VuePdfEmbed :source="getDocumentImageUrlManualAdjustment(event.photo)" />                                                         
                                                        </template>
                                                        <template v-else>
                                                            <b-img class="img_style" :src="getDocumentImageUrlManualAdjustment(event.photo)" />
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    {{ translationData.notAvailable }}
                                                </template>
                                            </b-modal>
                                        </template> 

                                        <template v-else>

                                            <b-col align-h="center" class="col-small roadmap-active">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                                <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                            </b-col>
                                            <b-col align-h="center" class="col-small roadmap-active">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/delivery_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">
                                                    <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                                    {{ translationData.onDelivery }}
                                                    </span>
                                                    <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                        {{ translationData.released }}
                                                    </span>
                                                    <span v-else>
                                                    {{ translationData.onRoute }}
                                                    </span>
                                                </p>
                                                <p class="roadmap_item_detail">{{ this.data.distribution[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                            </b-col>
                                            <b-col align-h="center" class="col-small roadmap-active">
                                                <span class="line line_active"> </span>
                                                <div class="icon_wrapper"><b-img src="@/assets/box_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                                <p class="roadmap_item_detail">{{ this.data.distribution[0].events[0].created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                            </b-col>
                                            <b-col align-h="center"  class="col-small roadmap-active" v-b-modal.modal_picture centered style="cursor: pointer;">
                                                <div class="icon_wrapper"><b-img src="@/assets/photo_green.png" fluid></b-img></div>
                                                <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                            </b-col>
                                            <b-modal centered size="xl" id="modal_picture" :title = "translationData.notePhoto" hide-footer>
                                                <template v-if="this.data.distribution[0].events[0].photo != null">
                                                    <template v-for="event in this.data.distribution[0].events">
                                                        <template v-if="event.photo.includes('.pdf')">
                                                            <VuePdfEmbed :source="getDocumentImageUrl(event.photo)" />                                                         
                                                        </template>
                                                        <template v-else>
                                                            <b-img class="img_style" :src="getDocumentImageUrl(event.photo)" />
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    {{ translationData.notAvailable }}
                                                </template>
                                            </b-modal>                                    
                                        </template> 
                                    </template> 
                                </template>
                            </template>
                        </template>
                            
                        <template v-else>
                            
                            <b-col sm="12">
                                <b-row class="mb-0">
                                    <b-col align-h="center" class="roadmap-active col-small">
                                        <span class="line line_active"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/file_green.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.noteIssued }}</p>
                                        <p class="roadmap_item_detail">{{ this.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>        
                                    </b-col>
                                    <b-col align-h="center" class="roadmap-disabled col-small">
                                        <span class="line"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/delivery.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">
                                            <span v-if="this.data.documentInfo.display_delivery === 'Em transporte'">
                                            {{ translationData.onDelivery }}
                                            </span>
                                            <span v-else-if="this.data.documentInfo.display_delivery === 'Liberado'">
                                                {{ translationData.released }}
                                            </span>
                                            <span v-else>
                                            {{ translationData.onRoute }}
                                            </span>
                                        </p>
                                        <p class="roadmap_item_detail"></p>
                                    </b-col>
                                    <b-col align-h="center" class="roadmap-disabled col-small">
                                        <span class="line"> </span>
                                        <div class="icon_wrapper"><b-img src="@/assets/box.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.delivered }}</p>
                                        <p class="roadmap_item_detail"></p>
                                    </b-col>
                                    <b-col align-h="center" class="roadmap-disabled col-small">
                                        <div class="icon_wrapper"><b-img src="@/assets/photo.png" fluid></b-img></div>
                                        <p class="roadmap_item_title">{{ translationData.clickToSee }}</p>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </template>
                    </template>
                </template>
            </b-row>
        </b-container>
        </b-card>
    </div>
</template>
<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed.js';
import TranslationEs from '../../locale/esp/translation_esp.json'
import TranslationPt from '../../locale/pt/translation_pt.json'
export default {
  name: 'Roadmap',
  props: ['data'],
  components: {
    VuePdfEmbed,
  },
  methods: {
    getDocumentImageUrl(eventPhoto) {
      return eventPhoto
    },
    getDocumentImageUrlManualAdjustment(eventPhoto) {
      return eventPhoto
    },
    getDocumentImageUrlTranshipment(eventPhoto) {
      return eventPhoto
        }
    },
      created() {
    const url = window.location.href;
    const langParam = 'lang=';
    const langIndex = url.indexOf(langParam);
    console.log('url: ', url);
    console.log('langIndex: ', langIndex);

    if (langIndex !== -1) {
      const langValue = url.substring(langIndex + langParam.length);
      this.language = langValue;
      console.log('this language: ', this.language);
    } else {
      // Se o parâmetro "lang" não for encontrado, defina um idioma padrão (por exemplo, português)
      this.language = 'pt';
    }

    if (this.language === 'esp' && TranslationEs) {
      this.translationData = TranslationEs;
      console.log('Translations (esp):', this.translationData);
    } else {
      this.translationData = TranslationPt;
      console.log('Translations (pt):', this.translationData);
    }
  },
    data () {
        return {
            manual: false,
            language: null,
            translationData: {}
        }
    },
    mounted() {
        if(this.data.manualAdjustment.length > 0 && this.data.distribution.length > 0 && (this.data.manualAdjustment[0].events[0].created == this.data.distribution[0].events[0].created)){
            if(this.data.distribution[0].events[0].photo == null){
                this.manual = true;
            }
        }else{
            this.manual = false;
        }
    }
}
</script>

<style>
#roadmap_wrapper{
    background: white;
    border-radius: 5px;
}

.icon_wrapper{
    background: #eeeeee;
    border-radius: 50%;
    padding: 20%;
    margin: 10px;
    z-index:1000;
    position: relative; 
}

.roadmap_item_title{
    font-weight: bold;
    font-size: 1.1em;
    line-height: 15px;
    text-align: center;
    margin-bottom: 10px;
    word-wrap: normal;
}

.roadmap_item_detail{
    font-size: 1em;
    line-height: 15px;
    margin-bottom: 5px;
    text-align: center;
}

.roadmap-active{
    color: #495057;
}

.roadmap-active .roadmap_item_detail{
    color: #7e8d9a;
}

.roadmap-disabled{
    color: rgb(167, 167, 167) !important;
}

.roadmap-disabled img{
    opacity: 0.1;
    filter: alpha(opacity=10) !important;
}

.roadmap-enabled img{
    opacity: 0.1;
    filter: alpha(opacity=10) !important;
}

.modal{
    background-color: transparent;
    max-height: 100%;
}

.col-small{
    margin-left: 1.5em !important;
    margin-right: 1.5 !important;
}

.card-roadmap{
    border-top: 1px solid #fcfcfc;
    border-bottom: 2px solid #5887d4 !important;
}

.line_active{
    border-bottom: 3px dashed #87d6ad !important;
}

.line{
    border-bottom: 3px dashed #dadada;
    width: 100%;
    margin-left: calc((10vw / 2));
    margin-top:  calc(50% - 10px);
    position:absolute;
    z-index: 100;
}

.img_style {
    width: 100%; 
    height: auto; 
    display: block; 
}

@media screen and (max-width: 767px) {
    .line{
        display: none;
    }

    .line_active{
        display: none;
    }
}
</style>
